import AlphaMatting from "./AlphaMatting.js";
import Blur from "./Blur.js";
import Equalizer from "./Equalizer.js";
import Grayscale from "./Grayscale.js";
import FilterBase from "./filterBase.js";
import Colorize from "./Colorize.js";
import Duotone from "./Duotone.js";

const creator = function (itemType, data = {}) {
    switch (itemType) {
        case "AlphaMattingFilterItem":
            return AlphaMatting.fromObject(data);
        case "BlurFilterItem":
            return Blur.fromObject(data);
        case "EqualizerFilterItem":
            return Equalizer.fromObject(data);
        case "GrayscaleFilterItem":
            return Grayscale.fromObject(data);
        case "ColorizeFilterItem":
            return Colorize.fromObject(data);
        case "DuotoneFilterItem":
            return Duotone.fromObject(data);
        default:
            return FilterBase.fromObject(data);
    }
}

export default creator;